import { render } from "./IgrejaAd.vue?vue&type=template&id=518b54cb&scoped=true"
import script from "./IgrejaAd.vue?vue&type=script&lang=js"
export * from "./IgrejaAd.vue?vue&type=script&lang=js"

import "./IgrejaAd.vue?vue&type=style&index=0&id=518b54cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518b54cb"]])

export default __exports__